const BookingDetailsTableRow = ({
  children,
  isGrandTotal,
  isTotal,
}: {
  children: React.ReactNode;
  isTotal?: boolean;
  isGrandTotal?: boolean;
}) => {
  // rendering booking details table row component here
  return (
    <div
      className={`grid grid-cols-booking-details-table py-2 rounded-md shadow-academia-sm [&>p:not(:first-child)]:text-center pl-3 ${
        isTotal
          ? 'bg-legal-dark-blue/20 text-legal-dark-green font-semibold'
          : isGrandTotal
          ? 'bg-legal-dark-blue text-legal-brown font-semibold'
          : 'bg-base-light-gray text-legal-dark-blue'
      }`}
    >
      {children}
    </div>
  );
};

export default BookingDetailsTableRow;
